import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=76dd019b&scoped=true&"
import script from "./LangSwitcher.vue?vue&type=script&lang=js&"
export * from "./LangSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./LangSwitcher.vue?vue&type=style&index=0&id=76dd019b&prod&lang=scss&scoped=true&"
import style1 from "./LangSwitcher.vue?vue&type=style&index=1&id=76dd019b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dd019b",
  null
  
)

export default component.exports